import { AccountClusterActions, AdminActions, ApplicationActions, PlatformActions, InstanceActions, LIBRARY_TYPE, OperationActions, } from "@orb-labs/orby-core";
import { TypedDataEncoder } from "ethers";
// similar to https://github.com/wevm/viem/blob/29c053f5069a5b44e3791972c221368a2c71a254/src/clients/decorators/public.ts#L1385
// https://github.com/wevm/viem/blob/29c053f5069a5b44e3791972c221368a2c71a254/src/clients/createPublicClient.ts#L48-L68
export const orbyActions = (client) => {
    const accountClusterActions = new AccountClusterActions(LIBRARY_TYPE.VIEM, client, undefined);
    const adminActions = new AdminActions(LIBRARY_TYPE.VIEM, client, undefined);
    const applicationActions = new ApplicationActions(LIBRARY_TYPE.VIEM, client, undefined);
    const instanceActions = new InstanceActions(LIBRARY_TYPE.VIEM, client, undefined);
    const operationActions = new OperationActions(LIBRARY_TYPE.VIEM, client, undefined);
    const blockchains = new PlatformActions(LIBRARY_TYPE.VIEM, client, undefined);
    return {
        createAccountCluster(accounts, authentication) {
            return accountClusterActions.createAccountCluster(accounts, authentication);
        },
        getVirtualNodeRpcUrlsForSupportedPlatforms(accountClusterId) {
            return accountClusterActions.getVirtualNodeRpcUrlsForSupportedPlatforms(accountClusterId);
        },
        enablePlatformAbstractionForAccountCluster(accountClusterId, enable) {
            return accountClusterActions.enablePlatformAbstractionForAccountCluster(accountClusterId, enable);
        },
        setCustomPlatformEndpointsForAccountCluster(accountClusterId, chainEndpoints) {
            return accountClusterActions.setCustomPlatformEndpointsForAccountCluster(accountClusterId, chainEndpoints);
        },
        removeCustomPlatformEndpointsForAccountCluster(accountClusterId, platformIds) {
            return accountClusterActions.removeCustomPlatformEndpointsForAccountCluster(accountClusterId, platformIds);
        },
        getCustomPlatformEndpointsForAccountCluster(accountClusterId, returnPlatformIdsOnly) {
            return accountClusterActions.getCustomPlatformEndpointsForAccountCluster(accountClusterId, returnPlatformIdsOnly);
        },
        isPlatformSupportedOnAccountCluster(accountClusterId, platformId) {
            return accountClusterActions.isPlatformSupportedOnAccountCluster(accountClusterId, platformId);
        },
        getNodeRpcUrl(accountClusterId, platformId) {
            return accountClusterActions.getNodeRpcUrl(accountClusterId, platformId);
        },
        getVirtualNodeRpcUrl(accountClusterId, platformId, entrypointAccountAddress) {
            return accountClusterActions.getVirtualNodeRpcUrl(accountClusterId, platformId, entrypointAccountAddress);
        },
        getActivity(accountClusterId, limit, offset, order, startDate, endDate, filters) {
            return accountClusterActions.getActivity(accountClusterId, limit, offset, order, startDate, endDate, filters);
        },
        getStablecoinAutoDepositSettingsForAccount(accountClusterId, account) {
            return accountClusterActions.getStablecoinAutoDepositSettingsForAccount(accountClusterId, account);
        },
        verifyAccounts(accounts) {
            return accountClusterActions.verifyAccounts(accounts);
        },
        createInstance(name) {
            return adminActions.createInstance(name);
        },
        getInstanceUrls(name) {
            return adminActions.getInstanceUrls(name);
        },
        getGasSpentForCustomer(month, year) {
            return adminActions.getGasSpentForCustomer(month, year);
        },
        getGasSpentForInstances(month, year, instanceNames) {
            return adminActions.getGasSpentForInstances(month, year, instanceNames);
        },
        isPlatformAbstractionCompatible(appDomainUrl) {
            return applicationActions.isChainAbstractionCompatible(appDomainUrl);
        },
        setCustomPlatformEndpointsForInstance(chainEndpoints) {
            return instanceActions.setCustomPlatformEndpointsForInstance(chainEndpoints);
        },
        removeCustomPlatformEndpointForInstance(platformIds) {
            return instanceActions.removeCustomPlatformEndpointForInstance(platformIds);
        },
        getCustomPlatformEndpointsForInstance(returnPlatformIdsOnly) {
            return instanceActions.getCustomPlatformEndpointsForInstance(returnPlatformIdsOnly);
        },
        enablePlatformAbstractionForInstance(enable) {
            return instanceActions.enablePlatformAbstractionForInstance(enable);
        },
        enableGasSponsorshipForInstance(enable) {
            return instanceActions.enableGasSponsorshipForInstance(enable);
        },
        getGasSponsorForInstance() {
            return instanceActions.getGasSponsorForInstance();
        },
        getOrbyGasSponsorPolicyForInstance() {
            return instanceActions.getOrbyGasSponsorPolicyForInstance();
        },
        setOrbyGasSponsorPolicyForInstance(gasSponsorshipPolicy) {
            return instanceActions.setOrbyGasSponsorPolicyForInstance(gasSponsorshipPolicy);
        },
        removeOrbyGasSponsorPolicyForInstance() {
            return instanceActions.removeOrbyGasSponsorPolicyForInstance();
        },
        getOperationsToExecuteTransaction(accountClusterId, data, to, value, gasToken) {
            return operationActions.getOperationsToExecuteTransaction(accountClusterId, data, to, value, gasToken);
        },
        getOperationsToSignTypedData(accountClusterId, data, gasToken) {
            return operationActions.getOperationsToSignTypedData(accountClusterId, data, gasToken);
        },
        getOperationsToSignTransactionOrSignTypedData(accountClusterId, data, to, value, gasToken, options) {
            return operationActions.getOperationsToSignTransactionOrSignTypedData(accountClusterId, data, to, value, gasToken, options);
        },
        getOperationsToCancelTransaction(accountClusterId, operationSetId) {
            return operationActions.getOperationsToCancelTransaction(accountClusterId, operationSetId);
        },
        getOperationsForStablecoinAutoDepositSettings(accountClusterId, settings, gasToken) {
            return operationActions.getOperationsForStablecoinAutoDepositSettings(accountClusterId, settings, gasToken);
        },
        isTransactionPreconditionSatisfied(accountClusterId, data, to, value, gasLimit, maxFeePerGas, maxPriorityFeePerGas, gasPrice) {
            return operationActions.isTransactionPreconditionSatisfied(accountClusterId, data, to, value, gasLimit, maxFeePerGas, maxPriorityFeePerGas, gasPrice);
        },
        isTypedDataPreconditionSatisfied(accountClusterId, data) {
            return operationActions.isTypedDataPreconditionSatisfied(accountClusterId, data);
        },
        sendSignedOperations(accountClusterId, signedOperations) {
            return operationActions.sendSignedOperations(accountClusterId, signedOperations);
        },
        getOperationsToSetupOnPlatform(platformId, account) {
            return operationActions.getOperationsToSetupOnPlatform(platformId, account);
        },
        submitOperationsToSetupOnPlatform(input) {
            return operationActions.submitOperationsToSetupOnPlatform(input);
        },
        getOperationStatuses(operationIds) {
            return operationActions.getOperationStatuses(operationIds);
        },
        getOperationSet(operationSetId) {
            return operationActions.getOperationSet(operationSetId);
        },
        getOperationsToTransferToken(accountClusterId, standardizedInstrumentId, amount, recipient, gasToken) {
            return operationActions.getOperationsToTransferToken(accountClusterId, standardizedInstrumentId, amount, recipient, gasToken);
        },
        getOperationsToSwap(accountClusterId, swapType, input, output, gasToken) {
            return operationActions.getOperationsToSwap(accountClusterId, swapType, input, output, gasToken);
        },
        getQuote(accountClusterId, swapType, input, output, paymentMethod, returnRouteInformation, meshBalances) {
            return operationActions.getQuote(accountClusterId, swapType, input, output, paymentMethod, returnRouteInformation, meshBalances);
        },
        getPlatformsSupportedByDefault() {
            return blockchains.getPlatformsSupportedByDefault();
        },
        getPlatformInformation(platformId) {
            return blockchains.getPlatformInformation(platformId);
        },
        listPlatformsInformation(offset, limit) {
            return blockchains.listPlatformsInformation(offset, limit);
        },
        initiateOAuthFlow(platformId, sessionId, parentOrigin) {
            return blockchains.initiateOAuthFlow(platformId, sessionId, parentOrigin);
        },
        subscribeToOperationStatuses(ids, onOperationStatusesUpdateCallback, timout) {
            return operationActions.subscribeToOperationStatuses(ids, onOperationStatusesUpdateCallback, timout);
        },
        subscribeToOperationSetStatus(operationSetId, onOperationSetStatusUpdateCallback, timout) {
            return operationActions.subscribeToOperationSetStatus(operationSetId, onOperationSetStatusUpdateCallback, timout);
        },
        sendOperationSet(accountCluster, operationSet, signTransaction, signUserOperation, signTypedData, submitOperation) {
            const signTypedDataFunction = async (operation) => {
                const parsedData = JSON.parse(operation.data);
                const message = {
                    ...TypedDataEncoder.getPayload(parsedData.domain, parsedData.types, parsedData.message),
                    primaryType: parsedData.primaryType,
                };
                if (!signTypedData) {
                    throw new Error("Please provide a signTypedData function");
                }
                return signTypedData({
                    ...operation,
                    data: JSON.stringify(message),
                });
            };
            return operationActions.sendOperationSet(accountCluster, operationSet, signTransaction, signUserOperation, signTypedDataFunction, submitOperation);
        },
        async sendOperationSetWithLocalOrchestration(accountCluster, operationSet, sendTransaction, sendUserOperation, signTypedData, onCompletionCallback, onOperationSubmissionCallback, timeout) {
            const signTypedDataFunction = async (operation) => {
                const parsedData = JSON.parse(operation.data);
                const message = {
                    ...TypedDataEncoder.getPayload(parsedData.domain, parsedData.types, parsedData.message),
                    primaryType: parsedData.primaryType,
                };
                if (!signTypedData) {
                    throw new Error("Please provide a signTypedData function");
                }
                return signTypedData({
                    ...operation,
                    data: JSON.stringify(message),
                });
            };
            return operationActions.sendOperationSetWithLocalOrchestration(accountCluster, operationSet, sendTransaction, sendUserOperation, signTypedDataFunction, onCompletionCallback, onOperationSubmissionCallback, timeout);
        },
    };
};
